import { doesMeetConditions } from '@atlassian/forge-conditions';

// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context';
import type { StaticContext, Extension } from '@atlassian/jira-forge-ui-types';

export const doesExtensionMeetConditions = <E extends Extension, EC extends Object>(
	extension: E,
	extraContext: EC,
): boolean => {
	const { displayConditions } = extension.properties;
	const {
		appPermissions: { hasSoftwareAccess, hasServiceDeskAccess, hasCoreAccess },
		isAdmin,
		isAnonymous,
		isSiteAdmin,
	} = getTenantContext_DEPRECATED_DO_NOT_USE();

	const context: StaticContext<EC> = {
		// Whatever extension needs
		...extraContext,

		// User info
		isAdmin,
		isLoggedIn: !isAnonymous,
		isSiteAdmin,

		// App permissions
		hasSoftwareAccess,
		hasServiceManagementAccess: hasServiceDeskAccess,
		hasCoreAccess,
	};

	return displayConditions ? doesMeetConditions(displayConditions, context) : true;
};
